/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_PlusInputs */

const en_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Plus Now`)
};

const ar_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترقية إلى Plus الآن`)
};

const de_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt auf Plus upgraden`)
};

const es_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Plus ahora`)
};

const fr_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Plus maintenant`)
};

const it_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Plus ora`)
};

const ja_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐPlusにアップグレード`)
};

const ko_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 Plus로 업그레이드`)
};

const pt_br_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinar o Plus agora`)
};

const ru_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на Plus сейчас`)
};

const th_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเกรดเป็น Plus ตอนนี้`)
};

const tr_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Plus’a yükselt`)
};

const zh_cn_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即升级 Plus`)
};

const zh_tw_upgrade_plus = /** @type {(inputs: Upgrade_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即升級 Plus`)
};

/**
* | output |
* | --- |
* | "Upgrade to Plus Now" |
*
* @param {Upgrade_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const upgrade_plus = /** @type {((inputs?: Upgrade_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_plus(inputs)
	if (locale === "ar") return ar_upgrade_plus(inputs)
	if (locale === "de") return de_upgrade_plus(inputs)
	if (locale === "es") return es_upgrade_plus(inputs)
	if (locale === "fr") return fr_upgrade_plus(inputs)
	if (locale === "it") return it_upgrade_plus(inputs)
	if (locale === "ja") return ja_upgrade_plus(inputs)
	if (locale === "ko") return ko_upgrade_plus(inputs)
	if (locale === "pt_br") return pt_br_upgrade_plus(inputs)
	if (locale === "ru") return ru_upgrade_plus(inputs)
	if (locale === "th") return th_upgrade_plus(inputs)
	if (locale === "tr") return tr_upgrade_plus(inputs)
	if (locale === "zh_cn") return zh_cn_upgrade_plus(inputs)
	return zh_tw_upgrade_plus(inputs)
});